import { mainSiteUrl } from "@/mocks/kakobuy";

export default function HeroSection() {
  return (
    <section className="relative w-full min-h-screen flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Vibrant%20fashion%20marketplace%20collage%20with%20colorful%20sneakers%20elegant%20leather%20bags%20designer%20hoodies%20and%20golden%20accessories%20scattered%20artistically%20on%20a%20rich%20textured%20charcoal%20backdrop%20with%20soft%20dramatic%20golden%20rim%20lighting%20creating%20a%20luxurious%20editorial%20vibe%20magazine%20quality%20composition%20high%20contrast%20deep%20shadows%20premium%20aesthetic&width=1920&height=1080&seq=kakobuy-hero-v2-2026&orientation=landscape"
          alt="Kakobuy Spreadsheet - produkty, moda i akcesoria w jednym miejscu"
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/25 to-black/50"></div>
      </div>

      <div className="relative z-10 w-full max-w-4xl mx-auto px-4 md:px-6 text-center pt-16">
        <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full border border-white/40 bg-white/10 backdrop-blur-sm mb-8">
          <span className="w-2 h-2 rounded-full bg-primary-400"></span>
          <span className="text-xs md:text-sm text-white font-medium tracking-wide">kakobuy spreadsheet</span>
        </div>

        <h1 className="text-4xl md:text-6xl lg:text-7xl font-heading font-bold text-white leading-tight mb-6">
          Kakobuy Spreadsheet
          <br />
          <span className="text-primary-300">Polska</span>
        </h1>

        <p className="text-base md:text-lg text-white/90 max-w-xl mx-auto leading-relaxed mb-10">
          Kompleksowe przewodniki zakupowe, listy produktów i porównania agentów.
          Znajdź najlepsze okazje z kakobuy spreadsheet.
        </p>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <a
            href={mainSiteUrl}
            target="_blank"
            rel="noopener nofollow"
            className="w-full sm:w-auto px-8 py-3.5 bg-white text-foreground-900 font-semibold text-sm rounded-full hover:bg-white/90 transition-all duration-300 whitespace-nowrap cursor-pointer shadow-lg shadow-black/20"
          >
            buy it now
          </a>
          <a
            href={mainSiteUrl}
            target="_blank"
            rel="noopener nofollow"
            className="w-full sm:w-auto px-8 py-3.5 border-2 border-white/50 text-white font-medium text-sm rounded-full hover:bg-white/15 transition-all duration-300 whitespace-nowrap cursor-pointer"
          >
            kakobuy spreadsheet
          </a>
        </div>

        <div className="mt-16">
          <a
            href="#kategorie"
            className="inline-flex flex-col items-center gap-2 text-white/70 hover:text-white transition-colors cursor-pointer"
          >
            <span className="text-xs tracking-widest uppercase">Odkryj kategorie</span>
            <span className="w-5 h-5 flex items-center justify-center animate-bounce">
              <i className="ri-arrow-down-line"></i>
            </span>
          </a>
        </div>
      </div>
    </section>
  );
}